import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import FormsDataService from "../../../../../services/FormsDataService";
import General from "../../../../../libs/utility/General";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { componentKey, setFormsList, setLoadingState, setSelectedForm } from "./ExportRecipientsDrawerSlice";
import RecipientDataService from "../../../../../services/RecipientDataService";
import { setExportToExcelModal } from "../RecipientListSlice";
import { PAGE_STATE } from "../../../constants/constants";
import { EXPORT_RECIPIENT_DRAWER_LOADING_STATES } from "./constants";

export const { getFormsList, exportAllRecipients, exportSelectedRecipients } = {

    getFormsList: (payload) => {
        return {
            type: "EXPORT_RECIPIENTS/GET_FORMS",
            payload
        }
    },

    exportAllRecipients: (payload) => {
        return {
            type: "EXPORT_RECIPIENTS/ALL",
            payload
        }
    },

    exportSelectedRecipients: (payload) => {
        return {
            type: "EXPORT_RECIPIENTS/SELECTED",
            payload
        }
    }
}

function* getFormsListAsync() {

    try {
        yield put(setLoadingState({ state: EXPORT_RECIPIENT_DRAWER_LOADING_STATES.EXPORT_RECIPIENT_FORMS_LOADING }));
        const response = yield FormsDataService.getCascadeForms();

        const { Message, Status, Data } = response?.data;

        if (Status) {
            const formList = [...Data];
            General.addOptionAndValueKeys(formList, "FormName1", "FormId")
            yield put(setFormsList(formList));

            const MISC_FORM = formList.find(form => form.FormName1 == "1099-MISC");

            if (MISC_FORM) {
                yield put(setSelectedForm(MISC_FORM))
            }
        } else {
            yield put(addNotifications({ heading: "Failed to fetch forms list", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(setExportToExcelModal(false));
        yield put(addNotifications({ heading: "Failed to fetch forms list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: EXPORT_RECIPIENT_DRAWER_LOADING_STATES.EXPORT_RECIPIENT_FORMS_READY }))
    }

}

function* exportAllRecipientsAsync({ payload }) {

    try {
        yield put(setLoadingState({ state: EXPORT_RECIPIENT_DRAWER_LOADING_STATES.EXPORT_ALL_RECIPIENTS_LOADING }));

        const response = yield RecipientDataService.recipientExportForAllPayers(payload?.label);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.downloadFileFromBase64(Data, "Recipients_Data.xls");
            yield put(setExportToExcelModal(false))
        } else {
            yield put(addNotifications({ heading: "Failed to export the recipients", message: Message }))
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to export the recipients", message: error?.response?.data?.Message }))
    } finally {
        yield put(setLoadingState({ state: EXPORT_RECIPIENT_DRAWER_LOADING_STATES.EXPORT_ALL_RECIPIENTS_READY }))
    }

}

function* exportSelectedRecipientsAsync({ payload }) {

    try {
        yield put(setLoadingState({ state: EXPORT_RECIPIENT_DRAWER_LOADING_STATES.EXPORT_SELECTED_RECIPIENTS_LOADING }));

        const { selectedForm, selectedPayer, selectedRecipients } = payload;

        const data = {
            "PayerID": selectedPayer?.PayerDetailId,
            "RecipientIds": selectedRecipients.map(rec => rec.RecipentDetailId),
            "IsAllSelect": false,
            "FormName": selectedForm?.label
        }

        const response = yield RecipientDataService.exportSelectedRecipients(data);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.downloadFileFromBase64(Data, "Selected_Recipients_Data.xls");
            yield put(setExportToExcelModal(false));
        } else {
            yield put(addNotifications({ heading: "Failed to export the recipients", message: Message }))
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to export the recipients", message: error?.response?.data?.Message }))
    } finally {
        yield put(setLoadingState({ state: EXPORT_RECIPIENT_DRAWER_LOADING_STATES.EXPORT_SELECTED_RECIPIENTS_READY }));
    }

}

function* rootSaga() {
    yield all([
        takeLatest(getFormsList().type, getFormsListAsync),
        takeLatest(exportAllRecipients().type, exportAllRecipientsAsync),
        takeLatest(exportSelectedRecipients().type, exportSelectedRecipientsAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
